// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N-Vjh","select":"styles_select__3tcu8"};